module.exports = __webpack_public_path__ + "img/white-card-display.b9680e1e.png";